"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var keyboard = require("../../_Core/Keyboard");
var ParentDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n\n    &[data-orientation='Vertical'] {\n        flex-direction: column;\n    }\n"], ["\n    display: inline-flex;\n\n    &[data-orientation='Vertical'] {\n        flex-direction: column;\n    }\n"])));
ParentDiv.displayName = "ParentDiv";
var RadioButton = /** @class */ (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setAsSelected = function (value) {
            React.Children.map(_this.props.children, function (child, index) {
                if (child.props.Value.toString() === value.toString()) {
                    _this.divContainer.children[index].firstElementChild.setAttribute("aria-checked", "true");
                    _this.divContainer.children[index].firstElementChild.setAttribute("tabindex", "0");
                }
                else {
                    _this.divContainer.children[index].firstElementChild.setAttribute("aria-checked", "false");
                    _this.divContainer.children[index].firstElementChild.setAttribute("tabindex", "-1");
                }
            });
        };
        _this.buildRef = function (e) {
            _this.divContainer = e;
        };
        _this.handleOnClick = function (e) {
            e.stopPropagation();
            var target = e.target;
            if (target.getAttribute("role") !== "radiogroup"
                && target.getAttribute("data-children") !== "children"
                && target.getAttribute("role") === "radio") {
                _this.setState({ Disabled: false });
                _this.setAsSelected(target.getAttribute("data-value"));
                _this.props.OnChange((target.getAttribute("data-value")));
            }
        };
        _this.handleKeyDown = function (e) {
            e.stopPropagation();
            var target = e.target;
            var targetParent = target.parentElement;
            if (keyboard.IsDownArrow(e) && _this.props.StackOrientation === "Vertical"
                || keyboard.IsRightArrow(e) && _this.props.StackOrientation === "Horizontal") {
                // we search for the next sibling which is not disabled
                var targetFound = false;
                var nextTarget = targetParent.nextSibling;
                while (nextTarget && !targetFound) {
                    var thisTarget = nextTarget.firstChild;
                    if (!thisTarget.disabled) {
                        targetFound = true;
                        thisTarget.focus();
                        _this.setAsSelected(thisTarget.getAttribute("data-value"));
                        _this.props.OnChange(thisTarget.getAttribute("data-value"));
                    }
                    else {
                        nextTarget = nextTarget.nextSibling;
                    }
                }
            }
            else if (keyboard.IsUpArrow(e) && _this.props.StackOrientation === "Vertical"
                || keyboard.IsLeftArrow(e) && _this.props.StackOrientation === "Horizontal") {
                // we search for the previous sibling which is not disabled
                var targetFound = false;
                var prevTarget = targetParent.previousSibling;
                while (prevTarget && !targetFound) {
                    var thisTarget = prevTarget.firstChild;
                    if (!thisTarget.disabled) {
                        targetFound = true;
                        thisTarget.focus();
                        _this.setAsSelected(thisTarget.getAttribute("data-value"));
                        _this.props.OnChange(thisTarget.getAttribute("data-value"));
                    }
                    else {
                        prevTarget = prevTarget.previousSibling;
                    }
                }
            }
        };
        return _this;
    }
    RadioButton.prototype.componentDidMount = function () {
        if (this.props.Value) {
            this.setAsSelected(this.props.Value);
        }
        else {
            var value = this.divContainer.firstElementChild.firstElementChild.getAttribute("data-value");
            this.setAsSelected(value);
        }
    };
    RadioButton.prototype.render = function () {
        var _this = this;
        var childrenWithProps = React.Children.map(this.props.children, function (child) {
            return React.cloneElement(child, { StackOrientation: _this.props.StackOrientation });
        });
        return (React.createElement(ParentDiv, { ref: this.buildRef, "data-orientation": this.props.StackOrientation, role: "radiogroup", onClick: this.handleOnClick, onKeyDown: this.handleKeyDown }, childrenWithProps));
    };
    return RadioButton;
}(React.PureComponent));
exports.RadioButton = RadioButton;
var templateObject_1;
